import React from 'react'

import { useNavigate } from 'react-router-dom';
export default function LabourPage() {
    const navigate = useNavigate();
    const [isAppMenuOpen, setIsAppMenuOpen] = React.useState(false);

    const [formData, setFormData] = React.useState({
        name: '',
        company: '',
        industry: '',
        email: '',
        phone: '',
        area: '',
        roles: {}
    });

     const [isSubmitting, setIsSubmitting] = React.useState(false);
    const [submitSuccess, setSubmitSuccess] = React.useState(false);
    const [submitError, setSubmitError] = React.useState(null);
    const [openDropdowns, setOpenDropdowns] = React.useState({});

    const roleCategories = {
        "MINERS MARKET EMPLOYEE / JOB ROLE LIST": {
            "EXECUTIVE MANAGEMENT": [
                "Chief Executive Officer (CEO)",
                "Chief Operating Officer (COO)",
                "Managing Director",
                "General Manager",
                "Executive Manager",
                "Mine Manager",
                "Resident Manager"
            ],
            "MINE MANAGEMENT": [
                "Production Manager",
                "Mining Manager",
                "Engineering Manager",
                "Engineering Superintendent",
                "Mining Superintendent",
                "Section Manager",
                "Shaft Manager",
                "Area Manager",
                "Mine Overseer",
                "Shift Boss",
                "Team Leader",
                "Supervisor",
                "Foreman",
                "GES",
                "Miner",
                "Miner Assistant"
            ],
            "MINING ENGINEERING": [
                "Graduate Mining Engineer",
                "Mining Engineer",
                "Senior Mining Engineer",
                "Principal Mining Engineer",
                "Chief Mining Engineer",
                "Rock Engineer",
                "Ventilation Engineer",
                "Mine Planning Engineer",
                "Drill & Blast Engineer",
                "Production Engineer",
                "Open Pit Engineer",
                "Underground Engineer",
                "Geotechnical Engineer",
                "Tailings Engineer"
            ],
            "MECHANICAL ENGINEERING": [
                "Graduate Mechanical Engineer",
                "Mechanical Engineer",
                "Senior Mechanical Engineer",
                "Principal Mechanical Engineer",
                "Reliability Engineer",
                "Maintenance Engineer",
                "Rotating Equipment Engineer",
                "Static Equipment Engineer",
                "Piping Engineer"
            ],
            "ELECTRICAL ENGINEERING": [
                "Graduate Electrical Engineer",
                "Electrical Engineer",
                "Senior Electrical Engineer",
                "High Voltage Engineer",
                "Low Voltage Engineer",
                "Power Systems Engineer",
                "Electrical Planner"
            ],
            "INSTRUMENTATION & CONTROL": [
                "Instrument Engineer",
                "Instrument Technician",
                "Automation Engineer",
                "Control Systems Engineer",
                "SCADA Engineer",
                "PLC Programmer",
                "Control & Instrumentation Engineer"
            ],
            "CIVIL & STRUCTURAL": [
                "Civil Engineer",
                "Structural Engineer",
                "Site Engineer",
                "Concrete Engineer",
                "Roads Engineer",
                "Water Engineer",
                "Construction Engineer"
            ],
            "METALLURGY & PROCESSING": [
                "Metallurgist",
                "Process Metallurgist",
                "Plant Metallurgist",
                "Senior Metallurgist",
                "Principal Metallurgist",
                "Process Engineer",
                "Plant Engineer",
                "Process Controller",
                "Control Room Operator",
                "Plant Operator",
                "Crushing Plant Operator",
                "Milling Operator",
                "Flotation Operator",
                "Thickener Operator",
                "Filter Plant Operator"
            ],
            "GEOLOGY": [
                "Chief Geologist",
                "Exploration Geologist",
                "Mine Geologist",
                "Resource Geologist",
                "Grade Control Geologist",
                "Engineering Geologist",
                "Geological Technician",
                "Core Logger",
                "Sampler"
            ],
            "SURVEY": [
                "Chief Surveyor",
                "Mine Surveyor",
                "Survey Technician",
                "Survey Assistant",
                "GIS Technician"
            ],
            "ROCK ENGINEERING": [
                "Rock Engineering Manager",
                "Rock Engineer",
                "Rock Mechanics Officer",
                "Geotechnical Technician"
            ],
            "SAFETY, HEALTH & ENVIRONMENT": [
                "SHE Manager",
                "HSE Manager",
                "Safety Manager",
                "Safety Officer",
                "Safety Representative",
                "Occupational Hygienist",
                "Environmental Manager",
                "Environmental Officer",
                "Environmental Specialist",
                "Occupational Health Practitioner",
                "Occupational Health Nurse",
                "Risk Officer",
                "Emergency Response Coordinator"
            ],
            "QUALITY": [
                "QA Manager",
                "QC Manager",
                "QA/QC Inspector",
                "Quality Engineer",
                "Welding Inspector",
                "NDT Technician",
                "Quality Controller"
            ],
            "MAINTENANCE": [
                "Maintenance Manager",
                "Maintenance Superintendent",
                "Maintenance Planner",
                "Maintenance Scheduler",
                "Reliability Specialist",
                "Workshop Manager"
            ],
            "ARTISANS": [
                "Millwright",
                "Electrician",
                "Auto Electrician",
                "Instrument Mechanician",
                "Boilermaker",
                "Fitter",
                "Fitter & Turner",
                "Diesel Mechanic",
                "Earthmoving Mechanic",
                "Heavy Equipment Mechanic",
                "Hydraulic Technician",
                "Refrigeration Technician",
                "Rigger",
                "Turner",
                "Machinist",
                "Welder",
                "Coded Welder",
                "Pipe Fitter",
                "Spray Painter"
            ],
            "OPERATORS": [
                "Excavator Operator",
                "Bulldozer Operator",
                "Grader Operator",
                "Front-End Loader Operator",
                "LHD Operator",
                "Dump Truck Operator",
                "ADT Operator",
                "Haul Truck Operator",
                "Drill Rig Operator",
                "Jumbo Operator",
                "Roof Bolter Operator",
                "Long Hole Drill Operator",
                "Raise Bore Operator",
                "Crusher Operator",
                "Winder Driver",
                "Locomotive Driver",
                "Winch Operator",
                "TMM Operator",
                "Crane Operator",
                "Forklift Operator"
            ],
            "MINING PRODUCTION": [
                "Charge Hand",
                "Blasting Assistant",
                "Blasting Technician",
                "Shotfirer",
                "Drill Assistant",
                "Belt Attendant",
                "Pump Attendant",
                "Stope Team Leader"
            ],
            "LABORATORY": [
                "Laboratory Manager",
                "Laboratory Supervisor",
                "Laboratory Technician",
                "Laboratory Assistant",
                "Assayer",
                "Chemist",
                "Analytical Chemist"
            ],
            "CONSTRUCTION & PROJECTS": [
                "Project Director",
                "Project Manager",
                "Construction Manager",
                "Site Manager",
                "Contracts Manager",
                "Project Engineer",
                "Project Coordinator",
                "Planner",
                "Scheduler",
                "Cost Engineer",
                "Quantity Surveyor",
                "Estimator",
                "Document Controller"
            ],
            "PROCUREMENT & SUPPLY CHAIN": [
                "Procurement Manager",
                "Supply Chain Manager",
                "Buyer",
                "Senior Buyer",
                "Purchasing Officer",
                "Expeditor",
                "Inventory Controller",
                "Warehouse Manager",
                "Warehouse Supervisor",
                "Storeman",
                "Logistics Coordinator",
                "Dispatch Supervisor"
            ],
            "FINANCE": [
                "Financial Director",
                "Financial Manager",
                "Finance Manager",
                "Financial Accountant",
                "Management Accountant",
                "Cost Accountant",
                "Payroll Administrator",
                "Creditors Clerk",
                "Debtors Clerk",
                "Finance Administrator"
            ],
            "HUMAN RESOURCES": [
                "HR Director",
                "HR Manager",
                "HR Business Partner",
                "HR Officer",
                "Recruitment Manager",
                "Recruitment Consultant",
                "Talent Acquisition Specialist",
                "Training Manager",
                "Training Officer",
                "Skills Development Facilitator",
                "Learning & Development Specialist",
                "Industrial Relations Officer",
                "Employee Relations Specialist"
            ],
            "INFORMATION TECHNOLOGY": [
                "IT Manager",
                "Systems Administrator",
                "Network Administrator",
                "Infrastructure Engineer",
                "IT Support Technician",
                "ERP Specialist",
                "SAP Consultant",
                "Cybersecurity Specialist",
                "Data Analyst"
            ]
        }
    };

    const handleCheckboxChange = (category, role) => {
        setFormData(prev => {
            const currentRoles = prev.roles;
            const key = `${category}||${role}`;
            if (currentRoles.hasOwnProperty(key)) {
                const newRoles = { ...currentRoles };
                delete newRoles[key];
                return { ...prev, roles: newRoles };
            } else {
                return { ...prev, roles: { ...currentRoles, [key]: 1 } };
            }
        });
    };

    const handleQtyChange = (category, role, delta) => {
        setFormData(prev => {
            const key = `${category}||${role}`;
            const current = prev.roles[key] || 0;
            const newQty = Math.max(1, current + delta);
            return { ...prev, roles: { ...prev.roles, [key]: newQty } };
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setSubmitError(null);

        try {
            const response = await fetch('/api/submit_labour.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            });

            const result = await response.json();

            if (!response.ok) {
                throw new Error(result.message || 'Failed to submit form');
            }

            setSubmitSuccess(true);
            setFormData({
                name: '',
                company: '',
                industry: '',
                email: '',
                phone: '',
                area: '',
                roles: {}
            });
        } catch (error) {
            setSubmitError(error.message);
        } finally {
            setIsSubmitting(false);
        }
    };

     const toggleDropdown = (category, e) => {
         if (e) {
             e.preventDefault();
             e.stopPropagation();
         }
         const wasOpen = openDropdowns[category];
         setOpenDropdowns(prev => ({
             ...prev,
             [category]: !prev[category]
         }));
         // After dropdown toggles, scroll the section into view to prevent jump
         setTimeout(() => {
             const safeId = category.replace(/\s+/g, '-').toLowerCase();
             const element = document.getElementById(`dropdown-${safeId}`);
             if (element && !wasOpen) {
                 element.scrollIntoView({ behavior: 'smooth', block: 'start' });
             }
         }, 50);
     };
 
     const CheckboxGroup = ({ title, roles, category }) => {
         const isOpen = openDropdowns[category];
         const safeId = category.replace(/\s+/g, '-').toLowerCase();
         return (
             <div id={`dropdown-${safeId}`} className="mb-4 border border-gray-200 rounded-lg overflow-hidden">
                 <button
                     type="button"
                     onClick={(e) => toggleDropdown(category, e)}
                     className="w-full flex items-center justify-between p-3 bg-gray-50 hover:bg-gray-100 transition-colors"
                 >
                     <h3 className="text-lg font-bold text-gray-900">{title}</h3>
                     <i className={`fas fa-chevron-${isOpen ? 'up' : 'down'} text-gray-500`}></i>
                 </button>
                 {isOpen && (
                     <div className="p-3 grid grid-cols-1 md:grid-cols-2 gap-2">
                         {roles.map((role, index) => {
                             const key = `${category}||${role}`;
                             const isSelected = formData.roles.hasOwnProperty(key);
                             const quantity = formData.roles[key] || 0;
 
                             return (
                                 <div key={index} className={`p-3 border rounded-lg transition-all ${isSelected ? 'border-blue-500 bg-blue-50/30' : 'bg-white border-gray-200'}`}>
                                     <div className="flex items-start justify-between gap-2">
                                         <label className="flex items-start space-x-2 cursor-pointer flex-1">
                                             <input
                                                 type="checkbox"
                                                 checked={isSelected}
                                                 onChange={() => handleCheckboxChange(category, role)}
                                                 className="mt-1 h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                                             />
                                             <span className="text-sm text-gray-700">{role}</span>
                                         </label>
                                         {isSelected && (
                                             <div className="flex items-center gap-2 bg-white border border-gray-200 rounded-lg px-2 py-1 flex-shrink-0">
                                                 <button type="button" onClick={() => handleQtyChange(category, role, -1)} className="text-blue-600 hover:text-blue-800 disabled:opacity-30 text-sm" disabled={quantity <= 1}><i className="fas fa-minus"></i></button>
                                                 <span className="text-sm font-black w-6 text-center text-gray-900">{quantity}</span>
                                                 <button type="button" onClick={() => handleQtyChange(category, role, 1)} className="text-blue-600 hover:text-blue-800 text-sm"><i className="fas fa-plus"></i></button>
                                             </div>
                                         )}
                                     </div>
                                 </div>
                             );
                         })}
                     </div>
                 )}
             </div>
         );
     };

    return (
        <div className="min-h-screen bg-gray-50">
            {/* Header */}
            <div className="bg-white border-b border-gray-200">
                <div className="container mx-auto px-4 py-4">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center gap-3">
                            <button
                                onClick={() => navigate('/')}
                                className="text-gray-600 hover:text-blue-600 transition-colors flex items-center gap-1"
                            >
                                <i className="fas fa-arrow-left"></i>
                                Back
                            </button>
                            <span className="text-lg font-bold text-gray-900 tracking-tight">Labour</span>
                        </div>
                        <button
                            onClick={() => setIsAppMenuOpen(true)}
                            className="p-2 text-gray-900 hover:text-blue-600 transition-colors"
                        >
                            <i className="fas fa-bars text-xl"></i>
                        </button>
                    </div>
                </div>
            </div>

            {/* App Navigation Sidebar (Slide-in) */}
            {isAppMenuOpen && (
                <div className="fixed inset-0 z-[100] flex justify-end">
                    <div className="absolute inset-0 bg-black/30 transition-opacity" onClick={() => setIsAppMenuOpen(false)}></div>
                    <div className="relative w-4/5 max-w-[400px] bg-white h-full shadow-2xl flex flex-col transform transition-transform duration-300 animate-slide-in-right overflow-hidden border-l border-gray-200">
                        <div className="p-4 border-b flex justify-between items-center bg-white sticky top-0 z-10">
                            <h2 className="text-lg font-bold text-gray-900">Application Menu</h2>
                            <button onClick={() => setIsAppMenuOpen(false)} className="text-gray-900 p-2"><i className="fas fa-times text-2xl"></i></button>
                        </div>
                        <div className="p-4 overflow-y-auto flex-grow space-y-2">
                            <button onClick={() => { navigate('/'); setIsAppMenuOpen(false); }} className="flex items-center gap-3 p-3 rounded-lg hover:bg-gray-100 text-gray-900 font-bold transition-colors w-full text-left"><i className="fas fa-home w-6"></i> Home</button>
                            <button onClick={() => { navigate('/equipment'); setIsAppMenuOpen(false); }} className="flex items-center gap-3 p-3 rounded-lg hover:bg-gray-100 text-gray-900 font-bold transition-colors w-full text-left"><i className="fas fa-truck-monster w-6"></i> Equipment</button>
                            <button onClick={() => { navigate('/consumables'); setIsAppMenuOpen(false); }} className="flex items-center gap-3 p-3 rounded-lg hover:bg-gray-100 text-gray-900 font-bold transition-colors w-full text-left"><i className="fas fa-box-open w-6"></i> Consumables</button>
                            <button onClick={() => { navigate('/miscellaneous'); setIsAppMenuOpen(false); }} className="flex items-center gap-3 p-3 rounded-lg hover:bg-gray-100 text-gray-900 font-bold transition-colors w-full text-left"><i className="fas fa-circle-notch w-6"></i> Miscellaneous</button>
                            <button onClick={() => { navigate('/rebuilds'); setIsAppMenuOpen(false); }} className="flex items-center gap-3 p-3 rounded-lg hover:bg-gray-100 text-gray-900 font-bold transition-colors w-full text-left"><i className="fas fa-tools w-6"></i> Rebuilds</button>
                            <button onClick={() => { navigate('/rentals'); setIsAppMenuOpen(false); }} className="flex items-center gap-3 p-3 rounded-lg hover:bg-gray-100 text-gray-900 font-bold transition-colors w-full text-left"><i className="fas fa-clock w-6"></i> Rentals</button>
                            <button onClick={() => { navigate('/commercial'); setIsAppMenuOpen(false); }} className="flex items-center gap-3 p-3 rounded-lg hover:bg-gray-100 text-gray-900 font-bold transition-colors w-full text-left"><i className="fas fa-briefcase w-6"></i> Commercial</button>
                            <button onClick={() => { navigate('/components-and-spares'); setIsAppMenuOpen(false); }} className="flex items-center gap-3 p-3 rounded-lg hover:bg-gray-100 text-gray-900 font-bold transition-colors w-full text-left"><i className="fas fa-cogs w-6"></i> Components</button>
                            <button onClick={() => { navigate('/financeform'); setIsAppMenuOpen(false); }} className="flex items-center gap-3 p-3 rounded-lg hover:bg-gray-100 text-green-600 font-bold transition-colors w-full text-left"><i className="fas fa-hand-holding-usd w-6"></i> Financing</button>
                            <button onClick={() => { navigate('/sheq'); setIsAppMenuOpen(false); }} className="flex items-center gap-3 p-3 rounded-lg bg-blue-50 text-blue-600 font-bold transition-colors w-full text-left"><i className="fas fa-shield-alt w-6"></i> SHEQ Services</button>
                            <button onClick={() => { navigate('/drill-catalog'); setIsAppMenuOpen(false); }} className="flex items-center gap-3 p-3 rounded-lg bg-orange-50 text-orange-600 font-bold transition-colors w-full text-left"><i className="fas fa-drill w-6"></i> Drill Catalog</button>
                            <button onClick={() => { navigate('/labour'); setIsAppMenuOpen(false); }} className="flex items-center gap-3 p-3 rounded-lg bg-green-50 text-green-600 font-bold transition-colors w-full text-left"><i className="fas fa-users w-6"></i> Labour</button>
                            <button onClick={() => { navigate('/kp-insurance'); setIsAppMenuOpen(false); }} className="flex items-center gap-3 p-3 rounded-lg hover:bg-gray-100 text-red-600 font-bold transition-colors w-full text-left"><i className="fas fa-crown w-6"></i> King Price</button>
                        </div>
                    </div>
                </div>
            )}

            {/* Form */}
            <div className="container mx-auto px-4 py-8">
                <div className="max-w-4xl mx-auto">
                    {submitSuccess ? (
                        <div className="bg-green-50 border border-green-200 rounded-lg p-8 text-center">
                            <i className="fas fa-check-circle text-5xl text-green-500 mb-4"></i>
                            <h2 className="text-2xl font-bold text-green-800 mb-2">Thank You!</h2>
                            <p className="text-green-700">Your Labour inquiry has been submitted successfully. We will contact you shortly.</p>
                            <button
                                onClick={() => setSubmitSuccess(false)}
                                className="mt-6 px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
                            >
                                Submit Another Inquiry
                            </button>
                        </div>
                    ) : (
                         <form onSubmit={handleSubmit} className="bg-white rounded-lg shadow-lg p-8">
                             {submitError && (
                                 <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
                                     <p className="text-red-700">{submitError}</p>
                                 </div>
                             )}
 
                              {/* Logos */}
                              <div className="flex items-center justify-center gap-4 mb-6 w-full">
                                  <div className="w-1/2 flex justify-center">
                                      <img
                                          src="labour-logo/bilnor-logo2.png"
                                          alt="BILNOR Logo"
                                          className="max-w-full h-auto"
                                      />
                                  </div>
                                  <div className="w-1/2 flex justify-center">
                                      <img
                                          src="images/logo/MM - Logo.jpeg"
                                          alt="Miners Market Logo"
                                          className="max-w-full h-auto"
                                      />
                                  </div>
                              </div>
 
                             {/* Contact Information */}
                            <div className="mb-8">
                                <h2 className="text-xl font-bold text-gray-900 mb-4 pb-2 border-b">Contact Information</h2>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Name *</label>
                                        <input
                                            type="text"
                                            name="name"
                                            value={formData.name}
                                            onChange={handleInputChange}
                                            required
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Company Name *</label>
                                        <input
                                            type="text"
                                            name="company"
                                            value={formData.company}
                                            onChange={handleInputChange}
                                            required
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Industry *</label>
                                        <input
                                            type="text"
                                            name="industry"
                                            value={formData.industry}
                                            onChange={handleInputChange}
                                            required
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Email *</label>
                                        <input
                                            type="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleInputChange}
                                            required
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Phone Number *</label>
                                        <input
                                            type="tel"
                                            name="phone"
                                            value={formData.phone}
                                            onChange={handleInputChange}
                                            required
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Area *</label>
                                        <input
                                            type="text"
                                            name="area"
                                            value={formData.area}
                                            onChange={handleInputChange}
                                            required
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Role Categories */}
                            <div className="mb-8">
                                <h2 className="text-xl font-bold text-gray-900 mb-4 pb-2 border-b">MINERS MARKET EMPLOYEE / JOB ROLE LIST</h2>
                                <p className="text-sm text-gray-500 mb-4">Select the roles you are interested in and specify quantities.</p>

                                {Object.entries(roleCategories["MINERS MARKET EMPLOYEE / JOB ROLE LIST"]).map(([category, roles]) => (
                                    <CheckboxGroup
                                        key={category}
                                        title={category}
                                        roles={roles}
                                        category={category}
                                    />
                                ))}
                            </div>

                            {/* Submit Button */}
                            <div className="flex justify-end">
                                <button
                                    type="submit"
                                    disabled={isSubmitting}
                                    className="px-8 py-3 bg-blue-600 text-white font-bold rounded-lg hover:bg-blue-700 transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed"
                                >
                                    {isSubmitting ? 'Submitting...' : 'Submit Inquiry'}
                                </button>
                            </div>
                        </form>
                    )}
                </div>
            </div>
        </div>
    );
}
